export default {"src":"/_next/static/media/quote-icon-white.02c28522.svg","height":34,"width":42,"blurWidth":0,"blurHeight":0};